<template>
  <div class="order">
    <van-tabs
      class="fea-tab"
      color="#0096FF"
      title-active-color="#0096FF"
      title-inactive-color="#333"
      @change="changeTab"
      :swipeable="true"
      :animated="true"
      :sticky="true"
      :style="'height:'+containHeight+'px'"
    >
      <van-tab v-for="(v,i) in tabList" :key="v.id" :title="v.name" :name="v.id">
        <div slot="title" class="title">
          <span>{{v.name}}</span>
          <span class="num" v-if="v.num!=0">({{v.num}})</span>
        </div>
        <div class="notmobile" v-if="noMobileShow">
          <span>找不到您的订单？绑定手机号试试~</span>
          <span class="close" @click="mobileShowOff">X</span>
        </div>
        <van-list
          v-model="v.dataList.loading"
          :finished="v.dataList.finished"
          finished-text="没有更多了"
          @load="getData(v,i)"
          ref="container"
        >
          <!-- @load="getData(v,i)" -->
          <van-cell class="no-border-cell">
            <ul class="card-list">
              <li v-for="item in v.dataList.list" :key="item.id">
                <div class="left" @click.stop="toDetail(item)">
                  <span class="head-tit">
                    <span>{{item.title}}</span>
                    <van-icon name="arrow" />
                  </span>
                  <div class="flex-box">
                    <img class="img" :src="item.img" alt />
                    <div class="box">
                      <span class="time">下单时间{{item.gmtCreate}}</span>
                      <span>
                        总价:
                        <i class="orange">￥{{item.price|priceFilter}}</i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <span
                    :class="'tag '+(item.status!==6&&item.status!==4?'blue':'grey')"
                  >{{item.status|orderStatusFilter}}</span>
                  <!-- 状态 1 待成团  -->
                  <van-button
                    v-if="item.status===1"
                    class="blue-btn"
                    @click="goReservation(item)"
                  >邀请好友</van-button>
                  <!-- 2 付过就算待使用  -->
                  <!-- <van-button
                    v-if="item.status===2"
                    class="blue-btn"
                    @click.stop="goReservation(item)"
                  >预约到店</van-button>-->
                  <!-- 3已使用 -->
                  <van-button
                    v-if="item.status===10"
                    class="blue-btn"
                    @click="goReservation(item)"
                  >评价</van-button>
                  <!--  5 退款审核中-->
                  <van-button
                    v-if="item.status===5"
                    class="grey-btn"
                    @click="goReservation(item)"
                  >取消退款</van-button>
                  <!--  6已退款 -->
                  <van-button
                    v-if="item.status===6"
                    class="grey-btn"
                    @click="goReservation(item)"
                  >退款详情</van-button>
                  <!--   7拼团失败 -->
                  <!-- <van-button v-if="item.status===7" class="blue-btn" @click="goReservation(item)">预约到店</van-button> -->
                  <!--  8已关闭 -->
                  <van-button
                    v-if="item.status===8"
                    class="grey-btn"
                    @click="goReservation(item)"
                  >删除</van-button>
                </div>
              </li>
            </ul>
          </van-cell>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
export default {
  name: "Order",
  data () {
    let list = [
      { id: "", name: "全部", num: 0, type: "qb" },
      { id: 2, name: "待使用", num: 0, type: "dsy" },
      { id: 3, name: "待评价", num: 0, type: "dpj" },
      { id: 1, name: "待成团", num: 0, type: "dct" },
      { id: 5, name: "退款", num: 0, type: "tk" }
    ];
    return {
      tabList: list.map(it => {
        return {
          ...it,
          dataList: {
            current: 1,
            size: 10,
            list: [],
            finished: false,
            loading: false // 异步加载状态
          }
        };
      }),
      container: null,
      containHeight: '',
      noMobileShow: false
    };
  },
  created () {
    this.getTotal();
    this.getUserInfo();
    localStorage.removeItem('reservation_form');
    localStorage.removeItem('selectedStore');
    // user/userOrder/statistics
  },
  mounted () {
    // this.container = this.$refs.container;
  },
  methods: {
    mobileShowOff () {
      this.noMobileShow = false;
    },
    // 查看用户信息  判断是否绑定手机号
    async getUserInfo () {
      try {
        let res = await this.request("/user/user/get", {});
        if (res.data.mobile && res.data.mobile === '') {
          this.noMobileShow = true;
        }
      } catch (e) {
        this.$error(e.message);
      }
    },
    cancelRefund (id) {
      this.$dialog
        .confirm({
          title: "提示",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          message: "确定要取消退款吗?"
        })
        .then(async () => {
          this.cancel(id);
        })
        .catch(() => { });
    },
    async cancel (id) {
      // console.log(123123123);

      let result = await this.request("/user/userOrder/cancelRefund", {
        id: id
      });
      // console.log(result);

      if (result.code === 0) {
        this.$error("取消成功");
        setTimeout(() => {
          this.goBack();
        }, 500);
      }
    },
    async getTotal () {
      try {
        let res = await this.request("/user/userOrder/statistics", {});
        // console.log(res);
        this.tabList = this.tabList.map(it => {
          return { ...it, num: res.data[it.type] };
        });
      } catch (e) {
        this.$error(e.message);
      }
    },
    reset () {
      this.tabList = this.tabList.map(it => {
        return {
          ...it,
          dataList: {
            current: 1,
            size: 10,
            list: [],
            finished: false,
            loading: false // 异步加载状态
          }
        };
      });
    },
    // 获取数据
    async getData (v, index) {
      // let param = {
      //   current: this.dataList.current,
      //   size: this.dataList.size,
      //   status: this.orderTab
      // };

      try {
        let pageJson = {
          page: this.tabList[index].dataList.current,
          limit: this.tabList[index].dataList.size
        };
        let form = {
          status: v.id
        };
        let result = await this.request("/user/userOrder/list", {
          ...pageJson,
          ...form
        });
        result.List = result.List.map(it => {
          return {
            ...it
          };
        });
        if (this.tabList[index].dataList.current === 1) {
          this.tabList[index].dataList.list = result.List;
        } else {
          this.tabList[index].dataList.list = [
            ...this.tabList[index].dataList.list,
            ...result.List
          ];
        }
        this.$nextTick(() => {
          if (result.List.length < result.TotalCount) {
            this.tabList[index].dataList.current++;
          }
          this.tabList[index].dataList.loading = false;
          // 数据全部加载完成
          if (this.tabList[index].dataList.list.length >= result.TotalCount) {
            this.tabList[index].dataList.finished = true;
          }

          this.containHeight = this.$refs.container.clientHeight;
        });
      } catch (e) {
        this.tabList[index].dataList.loading = false;
        this.tabList[index].dataList.finished = true;
        this.$error(e.message);
      }
    },
    // 切换状态栏
    changeTab (e) {
      console.log(e);
    },
    // 不同订单点击汇总
    goReservation (v) {
      // console.log(v);
      switch (v.status) {
        case 1: // 待成团就邀请好友
          this.go(`/Activity/Tuan?id=${v.activityId}&tuanId=${v.userOrderTuanId}&showHelp=true`);
          // this.go(`/Activity/Tuan?id=${v.activityId}&showHelp=true`);
          console.log("待成团");
          break;
        case 2: // 待使用就预约到店
          console.log("待使用");
          // if (v.isAppointment === 1) {
          //   this.$error("已预约");
          //   // this.$dialog
          //   //   .alert({
          //   //     title: "已预约",
          //   //     confirmButtonText: "好的",
          //   //     message: "门店将在1-3小时内安排预约事项,请耐心等待~",
          //   //     messageAlign: "left"
          //   //   })
          //   //   .then(() => {
          //   //   });
          // } else {
          //   this.go(
          //     `/reservation/${v.id}?activityId=${v.activityId}&orderId=${v.id}`
          //   ); // this.go('/reservationTwo?type=1&id=');
          // }

          break;
        case 3: // 待评价
          console.log("待评价");
          // this.go("/assess?id=" + v.id);
          break;
        case 4: // 已评价
          console.log("已评价");
          this.go("/comment?id=" + v.id);
          break;
        case 5: // 退款中
          console.log("退款中", v.id);
          this.cancelRefund(v.id);
          // this.go("/backMoney?id=" + v.id);
          // /backMoney
          break;
        case 6: // 已退款
          console.log("已退款", v.id);
          this.go("/backMoneyDetail?id=" + v.id);
          break;
        case 7: // 拼团失败
          console.log("退款中");
          break;
        case 8: // 已关闭
          console.log("已关闭");
          this.handleOrderDel(v);
          break;
        case 10: // 待评价
          console.log("待评价");
          this.go("/assess?id=" + v.id);
          break;
        default:
          break;
      }

      // this.go(`/reservation/${v.id}`);
    },
    // 删除订单
    async handleOrderDel (item) {
      // console.log(item);
      this.$dialog
        .confirm({
          title: "提示",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          message: "确定要删除订单吗?"
        })
        .then(async () => {
          // on close
          // this.goBack();
          let result = await this.request("/user/userOrder/del", {
            id: item.id
          });
          if (result.code === 0) {
            this.$error("删除成功");
            this.reset();
          }
        })
        .catch(() => { });
      // let result = await this.request("/user/userOrder/del", {});
      // console.log(result);
    },
    async toDetail (v) {
      // 待评价
      console.log('===========', v);
      // if (v.status === 3) {
      //   this.go("/comment?id=" + v.id);
      //   return;
      // }
      // 已评价
      if (v.status === 4) {
        this.go("/comment1?id=" + v.id);
        return;
      }
      // 待成团
      if (v.status === 1) {
        this.go("/grouped?id=" + v.id);
        return;
      }
      if (v.status === 5 || v.status === 6) {
        this.go("/backMoney?id=" + v.id);
        return;
      }
      if (v.status === 8) {
        this.go(`/close?id=${v.id}&status=${v.status}`);
        return;
      }
      if (v.status === 10) {
        this.go(`/eva?id=${v.id}&status=${v.status}`);
        return;
      }
      if (v.status === 7) {
        this.go(`/fail?id=${v.id}&status=${v.status}`);
        return;
      }
      this.go(`/beUsed?id=${v.id}`);
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
/deep/.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.van-cell:not(:last-child)::after {
  border: 0;
}
.van-cell {
  background: transparent;
}
.orange {
  color: #ff8c3e;
}
.blue {
  color: @baseColor;
}
.grey {
  color: #979797;
}

.order {
  .fea-tab {
    min-height: 100vh;
    overflow: hidden;
    background: #f7f7f7;
    /deep/.van-tabs__nav {
      .flex-center();
      .van-tab {
        flex: 1;
      }
      .van-tabs__line {
        height: 0;
        bottom: 22px;
        border-top: 3px solid @baseColor;
        width: 10px !important;
        border-radius: 10px;
      }
    }
  }
  .card-list {
    li {
      background: #fff;
      padding: 10px;
      margin-bottom: 10px;
      .flex-center();
      justify-content: space-between;
      .left {
        .head-tit {
          margin-bottom: 10px;
          .flex-center();
          justify-content: flex-start;
          .sc(14px, #333);
          i {
            font-size: 12px;
          }
          span {
            display: inline-block;
            white-space: nowrap;
            width: 120px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .flex-box {
          .flex-center();
          .img {
            width: 60px;
            border-radius: 3px;
          }
          .box {
            padding: 0 8px;
            font-size: 13px;
            span {
              display: block;
            }
            .time {
              white-space: nowrap;
              padding-bottom: 5px;
            }
            i {
              font-style: normal;
            }
          }
        }
      }
      .right {
        font-size: 13px;
        text-align: right;
        height: 90px;
        display: flex;
        flex-direction: column;
        justify-content: inherit;
        .van-button {
          padding: 0;
          font-size: 13px;
          height: 25px;
          line-height: 25px;
          padding: 0 2px;
          white-space: nowrap;
          border: 1px solid #ccc;
          color: #585858;
        }
        .blue-btn {
          width: 62px;
          border: 1px solid @baseColor;
          color: @baseColor;
        }
        .grey-btn {
          width: 62px;
          border: 1px solid #c2c1c1;
          color: #585858;
        }
      }
    }
  }
  .notmobile {
    background: #fff;
    width: 100%;
    height: 30px;
    font-size: 14px;
    text-align: left;
    line-height: 30px;
    border-top: 1px solid #999999;
    border-bottom: 1px solid #999999;
    span {
      margin-left: 5px;
    }
    .close {
      float: right;
      color: red;
      width: 30px;
      text-align: right;
      margin-right: 5px;
    }
  }
}
</style>